import { Icon } from '../Icon';

import { Wrapper, Title, Text } from './WarningMessage.styles';

interface WarningMessageProps {
  title: string;
  text: string;
}

export const WarningMessage: React.FC<WarningMessageProps> = ({ title, text }) => {
  return (
    <Wrapper>
      {title && (
        <Title>
          <Icon i="Warning" color="orange6" />
          <span>{title}</span>
        </Title>
      )}
      {text && <Text>{text}</Text>}
    </Wrapper>
  );
};
